import { useEffect, useRef } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { IconDispatcher } from "shared/Icons";
import { GenericButton } from "shared/ui-basics";
import { CustomOverlayPanel, DropdownContainer, ItemSelectorCard } from "./filters_style";

const FilterBy = ({ apply }) => {
	const { t } = useTranslation();
	const op = useRef();
	const currentFilterBy = useSelector((state) => state.analytics?.roiAnalysis?.selectedFilterOptions?.filterBy);
	const selectedDetails = getFilterDetails(currentFilterBy);

	//useEffect(() => {}, [currentFilterBy]);

	const onClickSelect = (e, filterName) => {
		op.current.toggle(e);
		apply({ dataAttribute: "filterBy", selectedItems: filterName });
	};

	return (
		<div>
			<GenericButton variant="light" icon={selectedDetails?.icon} iconClassName="me-2" onClick={(e) => op.current.toggle(e)}>
				<div>{t(selectedDetails?.title)}</div>
			</GenericButton>
			<CustomOverlayPanel ref={op}>
				<DropdownContainer>
					<ItemSelectorCard className="p-4" onClick={(e) => onClickSelect(e, "cjms")}>
						<div>{IconDispatcher("CJM")}</div>
						<div>{t("FILTER_BY_JOURNEY_MAPS")} </div>
					</ItemSelectorCard>
					<ItemSelectorCard className="p-4" onClick={(e) => onClickSelect(e, "projects")}>
						<div>{IconDispatcher("PROJECT-LIGHT")}</div>
						<div>{t("FILTER_BY_PROJECTS")} </div>
					</ItemSelectorCard>
				</DropdownContainer>
			</CustomOverlayPanel>
		</div>
	);
};

const getFilterDetails = (currentFilterBy) => {
	if (currentFilterBy === "cjms") return { title: "FILTER_BY_JOURNEY_MAPS", icon: "CJM" };
	return { title: "FILTER_BY_PROJECTS", icon: "PROJECT-LIGHT" };
};

export default FilterBy;
